import type {
  EquityRelated,
  ETFRelated,
  MutualFundRelated,
} from '#/api/generated/fINRAMarketDataAPI.schemas';
import { CategoryCard } from '#/components/ui/CategoryCard';
import { SectionHeader } from '#/components/ui/SectionHeader';
import type { ProductTypeSlug } from '#/types';

const RELATED_SECTION_TITLES: Record<ProductTypeSlug, string> = {
  equities: 'Equity',
  etfs: 'ETF',
  'mutual-funds': 'Mutual Fund',
};

interface RelatedSectionProps {
  category: ProductTypeSlug;
  fundCategory?: string | null;
  data: EquityRelated | ETFRelated | MutualFundRelated | null | undefined;
}

export function RelatedSection({
  category,
  fundCategory,
  data,
}: RelatedSectionProps) {
  if (!data) {
    return null;
  }

  const title = RELATED_SECTION_TITLES[category];

  return (
    <section
      id="related"
      className="flow flow-inner-20 scroll-mt-(--scroll-offset)"
    >
      <SectionHeader
        title={`Related to this ${title}`}
        actionAlignment="center"
      />

      {fundCategory && (
        <div className="grid-cols1 gap-gap grid md:grid-cols-2">
          <CategoryCard eyebrow="Fund Category" title={fundCategory} />
        </div>
      )}
    </section>
  );
}
